export const RSVP_FEATURE_KEY = "wedding.rsvp.enabled";

export function isRsvpEnabled(): boolean {
  return window.localStorage.getItem(RSVP_FEATURE_KEY) === "true";
}
